import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { history } from 'kts-platform-frame/routes';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import ReduxState, { IUser } from 'kts-platform-frame/redux/ReduxState';
import { Layout, Form, Button, Card, Input, Icon, Row, Col, Tabs, message } from 'antd';
import JSString from 'kts-scaffold-framework/utils/kit/JSString';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { passConfig } from 'kts-platform-frame/utils';
const logoImg = require('./img/LOGO.png');
const css = require('./index.scss');
const FormItem = Form.Item;
const { Header, Content, Footer } = Layout;
const TabPane = Tabs.TabPane;
const formItemLayout = {
    labelCol: {
        span: 7
    },
    wrapperCol: {
        span: 16
    },
};
const tailFormItemLayout = {
    wrapperCol: {
        span: 16,
        offset: 7
    },
};
/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 选中公司面板 */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class SetPassword extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentWillMount() {
        const params = JSString.queryStringParse(this.props.location.search);
        if (params.type === 'rest') {
            this.handelResetForgetPswCheck(params.ticket);
        } else if (params.type === 'invite') { // 邀请 
            this.handelInviteSetPswCheck(params.ticket);
        } else {
            history.push(`/`);
        }

        // 获取 url 参数
        this.modulesState.type = params.type;
        this.modulesState.ticket = params.ticket;
        this.setModulesState(this.modulesState);
    }

    render() {
        const { form } = this.props;
        const { getFieldDecorator } = form;

        // 显示邮箱
        const { email } = this.modulesState;

        const { config } = MyStore.instance.getState();
        const _config = JSON.parse(JSON.stringify(config));
        console.log(_config);
        const passConfigArr = this.modulesState.passConfigArr;
        return (
            <Layout className="reset-password">
                {/* <Header className="top header">
                    <div className="logo">
                        <div className="left"><img alt={'logo'} src={ _config.rootConfig.SiteLogo} /></div>
                        <div className="left site-name">{ _config.rootConfig.SiteName}</div>
                    </div>
                </Header> */}
                <Content style={{ width: 900 }} className={"reset-password-content"}>
                    <div className="yllogo">
                        <div className="yllogoimg">
                            {/* <img alt={'logo'} src={ _config.rootConfig.SiteLogo} /> */}
                            <img alt={'logo'} src={logoImg} />
                            <span className="yllogotitle"> | {this.modulesState.type === 'invite' ? '用户注册' : '找回密码'}</span>
                        </div>
                    </div>
                    {!this.modulesState.isSetSuccess &&
                        <div className="ant-card ant-card-bordered">
                            <div className="ant-card-body">
                                <Form>
                                    <FormItem colon={false} label="电子邮箱" {...formItemLayout}>
                                        <span className={css['reset-password-gray']}>{email || '数据有误'}</span>
                                        <div className="title-info">您可以通过您的电子邮箱登录系统。您也可以通过电子邮箱接收系统消息和重置密码。</div>
                                    </FormItem>
                                    <div className={css['find-newPsd']}>
                                        <FormItem colon={false} label="新密码" {...formItemLayout}>
                                            {getFieldDecorator("newPassword", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: '请输入密码'
                                                    },
                                                    {
                                                        validator: this.newPsdCheck
                                                    }
                                                ]
                                            })(<Input
                                                size="large"
                                                type="password"
                                                className="inputw"
                                                placeholder="请输入密码"
                                                onChange={this.newPasswordCheck}
                                                onFocus={this.newPasswordFocus}
                                                onBlur={this.newPasswordBlur}
                                            />)}
                                        </FormItem>
                                        {
                                            (this.modulesState.newPasTipView && !this.modulesState.passConcigArrView) && <p className={css['find-newPsd-tip']}>{this.modulesState.newPasTipMessage}</p>
                                        }
                                        {
                                            this.modulesState.passConcigArrView &&
                                            <div className={css['find-newPsd-judge']}>
                                                {
                                                    passConfigArr && passConfigArr.map(el => {
                                                        return (
                                                            <span
                                                                key={el['message']}
                                                                className={css['fnj-info']}
                                                            >
                                                                {el['message']}
                                                                {
                                                                    el['statu'] ? <Icon type="zhengque" /> : <Icon type="cuowu" />
                                                                }
                                                            </span>
                                                        );
                                                    })
                                                }
                                            </div>
                                        }
                                    </div>
                                    <FormItem
                                        colon={false}
                                        {...formItemLayout}
                                        label="确认新密码"
                                    >
                                        {getFieldDecorator("newPassword2", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请输入密码'
                                                },
                                                {
                                                    validator: this.compareToFirstPassword,
                                                }
                                            ]
                                        })(<Input size="large" className="inputw" type="password" placeholder="请输入密码" onBlur={this.handleConfirmBlur} />)}
                                    </FormItem>
                                    <FormItem
                                        {...tailFormItemLayout}
                                    >
                                        <div>
                                            <Button
                                                type="primary"
                                                size="large"
                                                onClick={this.handleSubmit}
                                            >
                                                {this.modulesState.type === 'invite' ? '注册' : '找回密码'}
                                            </Button>
                                            <Button
                                                style={{ marginLeft: 20 }}
                                                size="large"
                                                onClick={() => { history.push(`/modifypas`); }}
                                            >
                                                放弃
                                            </Button>
                                        </div>
                                    </FormItem>
                                </Form>
                            </div>
                        </div>
                    }
                    {this.modulesState.isSetSuccess &&
                        <div className="ant-card ant-card-bordered">
                            <div className="ant-card-body">
                                <div className="reset-sucuss">
                                    <p className={"tip-succ"}>恭喜您，您的新密码已经设置成功！</p>
                                    {
                                        this.modulesState.type === 'rest' &&
                                        <Button className={"login-link"} type="primary" onClick={() => { MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null }); history.push(`/`); }}>点击登录</Button>  // 1. 正常设置密码登录，跳转到主页登录界面
                                    }
                                    {
                                        this.modulesState.type === 'invite' &&
                                        <Button className={"login-link"} type="primary" onClick={this.invaiteJoinCompany}>登录并加入公司</Button> // 2. 通过邀请设置密码登录，跳转到邀请登录界面
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    <div className="restfooter">
                        <p><Icon type="phone" /> 服务热线 ：400-836-3566&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;<Icon type="mail" /> <a href="mailto: support@kingxunlian.com">support@kingxunlian.com</a></p>
                        <p className="xunlianjt">迅联集团 2018 粤ICP备17007740号-1</p>
                    </div>
                </Content>
            </Layout>
        );
    }
    /** 通过邀请的登录，跳转到邀请加入公司登录页面 */
    private invaiteJoinCompany = async () => {
        history.push('/login/joincompany');
    }

    private judgeSubmit = (opt) => {
        return opt['statu'] === true;
    }

    /** 提交重置密码 */
    private handleSubmit = (): void => {
        let passConfigArr = this.modulesState.passConfigArr;
        let passConfigArrStatu = passConfigArr.every(this.judgeSubmit);
        this.props.form.validateFields(async (er: any, values: any) => {
            if (er != null) {
                return;
            }
            if (!er && passConfigArrStatu) {
                if (this.modulesState.type === 'rest') {
                    await ModulesAction.resetForgetPswDo(values.newPassword);
                } else {
                    await ModulesAction.activePwd(values.newPassword); //  ModulesAction.resetForgetPswDo(values.newPassword);
                }
            }
        });
    }

    /** 重置密码，验证 ticket */
    private handelResetForgetPswCheck = async (ticket: string) => {
        const CheckData = await ModulesAction.resetForgetPswCheck(ticket);
        if (!CheckData) {
            message.error('该链接已失效,3秒后跳转到登录页面');

            setTimeout(() => {
                history.push(`/`);
            }, 3000);
        }
    }

    /** 邀请登录设置密码，验证 ticket */
    private handelInviteSetPswCheck = async (ticket: string) => {
        ModulesAction.inviteSetPswCheck(ticket);
    }

    private passTip = (b) => {
        ModulesAction.changeNewPasTipView(b);
    }

    private newPasswordFocus = () => {
        ModulesAction.changeNewPasTipView(true);
        // ModulesAction.changePassConfigArrView(false);
    }

    private newPasswordBlur = () => {
        ModulesAction.changeNewPasTipView(false);
        ModulesAction.changePassConfigArrView(true);
        let newPassword = this.props.form.getFieldsValue(['newPassword']);
        const passConfigArr = passConfig(this.modulesState.passConfig, newPassword['newPassword']);
        ModulesAction.changePassConfigArr(passConfigArr);
    }

    private compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('newPassword')) {
            callback('两次密码不一致');
        } else {
            callback();
        }
    }

    private newPsdCheck = (rule, value, callback) => {
        let newPassword = this.props.form.getFieldsValue(['newPassword']);
        const passConfigArr = passConfig(this.modulesState.passConfig, newPassword['newPassword']);
        if (newPassword && this.modulesState.confirmDirty) {
            this.props.form.validateFields(['newPassword2'], { force: true }, () => { });
        }
        if (!passConfigArr.every(this.judgeSubmit)) {
            callback(' ');
        } else {
            callback();
        }
    }

    private newPasswordCheck = (e) => {
        const passConfigArr = passConfig(this.modulesState.passConfig, e.target.value);
        ModulesAction.changePassConfigArr(passConfigArr);
    }

    private handleConfirmBlur = () => {
        ModulesAction.updateConfirmDirty();
    }
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/Login/UI.SetPassword.tsx